import BusinessBankStatement from './BusinessBankStatement/BusinessBankStatement';
import AgedDebtorReport from './OptionalStatement/AgedDebtorReport/AgedDebtorReport';
import ArticlesOfAssociation from './OptionalStatement/ArticlesOfAssociation/articlesOfAssociation';
import BusinessPlans from './OptionalStatement/BusinessPlan/BusinessPlan';
import Bwa from './OptionalStatement/BWA/bwa';
import BwaSusa from './OptionalStatement/BWA_SuSa/bwa_susa';
import BwaSusaAnnual from './OptionalStatement/BWA_SuSa_Annual/BWA_SuSa_Annual';
import CompanyAccount from './OptionalStatement/CompanyAccounts/CompanyAccount';
import CurrentManagementAccount from './OptionalStatement/ManagementAccounts/CurrentMangementAccount';
import ShareRegister from './OptionalStatement/ShareRegister/shareRegister';
import TradeCertificate from './OptionalStatement/TradeCertificate/tradeCertificate';
import { DocRequirementFileTypes, TOffersDataRequirements } from './types';
import VATStatement from './VATStatement/VATStatement';
import { RootState } from '../../reducers';

// TODO: Add missing corresponding components
export const RequirementSections: { [key: string]: React.ElementType } = {
    // UK requirments
    bank_statement: BusinessBankStatement,
    link_bank_account_via_open_banking: BusinessBankStatement,
    // link_open_banking: BusinessBankStatement, // don't think this is ever used
    // via_open_banking: BusinessBankStatement, // don't think this is ever used
    // business_accounts: null,
    company_accounts: CompanyAccount,
    management_accounts: CurrentManagementAccount,
    business_plan: BusinessPlans,
    aged_debtor_report: AgedDebtorReport,
    vat_return: VATStatement,

    //DE Requirements
    kontoauszuege_hochladen: BusinessBankStatement,
    bwa_hochladen: Bwa,
    bwa_susa_hochladen: BwaSusa,
    jaehrliche_bwa_susa_hochladen: BwaSusaAnnual,
    gesellschaftsvertrag_hochladen: ArticlesOfAssociation,
    gewerbeschein_hochladen: TradeCertificate,
    aktienregisterauszug_hochladen: ShareRegister
};

export const documentTypes: { [key: string]: DocRequirementFileTypes } = {
    aged_debtor_report: 'aged debtor report',
    bank_statement: 'bank statement',
    management_accounts: 'management accounts',
    vat_return: 'vat return',
    company_accounts: 'business accounts',
    business_accounts: 'business accounts',
    business_plan: 'business plan',

    // DE
    bwa_hochladen: 'management accounts',
    bwa_susa_hochladen: 'management and balance accounts',
    jaehrliche_bwa_susa_hochladen: 'year end management and balance accounts',
    gesellschaftsvertrag_hochladen: 'articles of association',
    gewerbeschein_hochladen: 'trade certificate',
    aktienregisterauszug_hochladen: 'share registry'
};

const filterDocumentType = (requirements: TOffersDataRequirements) => {
    return requirements.filter(
        (requirement: TOffersDataRequirements[number]) => {
            return requirement.category === 'documents';
        }
    );
};

export const getDocumentRequirements = ({
    requirements,
    isOptional,
    isBusinessDetailsReductionSplitTest
}: {
    requirements: TOffersDataRequirements;
    isOptional: boolean;
    isBusinessDetailsReductionSplitTest: boolean;
}) => {
    if (!requirements) return [];

    const dataRequirementCategory = filterDocumentType(requirements);

    return dataRequirementCategory[0].actions.filter((action) => {
        if (isBusinessDetailsReductionSplitTest && action.type === 'vat_return')
            return;

        return action.is_optional === isOptional;
    });
};

export function getApplicationSuggestedProduct(state: RootState) {
    return state?.lendingAPI?.application?.data?.requested_products[0]
        ?.suggested_product;
}

export const getVatDocRequirement = (requirements: TOffersDataRequirements) => {
    if (!requirements) return null;

    const dataRequirementCategory = filterDocumentType(requirements);

    const vatReturn = dataRequirementCategory[0].actions.filter((action) => {
        return action.type === 'vat_return';
    });

    return vatReturn[0] || null;
};
